import { RemoteChangePasswordProfile } from 'data/usecases';
import { makeApiUrlProfile } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteChangePasswordProfile =
  (): RemoteChangePasswordProfile => {
    return new RemoteChangePasswordProfile(
      makeApiUrlProfile(),
      makeAxiosHttpClient(),
    );
  };
